import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { styled } from '@mui/material/styles';

const ProgressCircle = styled(motion.div)(({ theme }) => ({
  position: 'fixed',
  height: '4rem',
  width: '4rem',
  borderRadius: '100%',
  backgroundColor: theme.palette.secondary.main,
  opacity: 0.6,
  zIndex: theme.zIndex.modal,
}));

interface ProgressProps {
  isVisible: boolean;
}

const Progress = ({ isVisible }: ProgressProps) => {
  const initial = {
    scale: 0,
  };
  const animate = {
    scale: [0, 1],
  };
  const transition = {
    duration: 1.05,
    ease: 'easeInOut' as const,
    repeat: Infinity,
    repeatType: 'reverse' as const,
  };
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          style={{
            position: 'absolute',
            top: 'calc(50% - 2rem)',
            left: 'calc(50% - 2rem)',
          }}
        >
          <ProgressCircle
            initial={initial}
            animate={animate}
            transition={{ ...transition, delay: 1.05 }}
          />
          <ProgressCircle
            initial={initial}
            animate={animate}
            transition={{
              ...transition,
              delay: 2.1,
            }}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Progress;
